import { Link } from 'react-router-dom';
import { channelLabel, type GossipItem } from '@/mocks/gossip';

export const formatViews = (n: number) => {
  if (n >= 100000) return `${(n / 10000).toFixed(1)}w`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return String(n);
};

const hotTagClass = (t?: '爆' | '热' | '新') => {
  if (t === '爆') return 'bg-accent-500 text-background-50';
  if (t === '热') return 'bg-primary-500 text-background-50';
  return 'bg-secondary-500 text-background-50';
};

export default function NewsCard({ item }: { item: GossipItem }) {
  return (
    <Link
      to={`/news/${item.slug}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[10/7] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 flex items-center gap-2">
          <span className="rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-700">
            {channelLabel(item.channel)}
          </span>
          {item.hotTag && (
            <span className={`rounded-full px-2 py-1 text-xs font-black ${hotTagClass(item.hotTag)}`}>
              {item.hotTag}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{item.summary}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
          <span>{item.date}</span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(item.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {item.readTime} 分钟
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}